<div mat-dialog-content class="w-full bg-white !p-0 !m-0" style="width: 400px;">
  <div class="modal-inner">
    <img class="logo" src="../../../assets/img/qhantuy/logo.png" alt="logo">
    <h2>Qh Suite - Aprobaciones</h2>
    <p class="mb-4">Para poder aprobar la solicitud, por favor ingresa tu contraseña </p>
   <div class="row">
    <div class="col-md-12">
      <div class="form-wrapper mb-3">
        <span>Correo electrónico:</span>
        <input type="email" value="correo@qhsuite.com">
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-wrapper mb-3">
        <span>Contraseña:</span>
        <input type="password">
      </div>
    </div>
   </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex flex-wrap justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button>
        <button mat-button type="button" class="btn btn-second big">Aprobar</button>
  </div>
</div>
